// extracted by mini-css-extract-plugin
export default {"imageContainer":"ReservationType_imageContainer__J2S9h"};